function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import * as React from "react";
import DatePicker from "react-datepicker";
import Select from "react-select";
import PrimaForm from "../PrimaForm";

var CancellationForm = function CancellationForm(props) {
  var _polizaEndorsementFor;

  var poliza = props.poliza,
      polizaEndorsement = props.polizaEndorsement,
      polizaEndorsementForm = props.polizaEndorsementForm,
      onChangeDuration = props.onChangeDuration,
      onChangeAmount = props.onChangeAmount,
      cancelReasons = props.cancelReasons,
      setPolizaEndorsementForm = props.setPolizaEndorsementForm;
  props;
  var defaultCancelReason = cancelReasons.find(function (reason) {
    return (polizaEndorsement === null || polizaEndorsement === void 0 ? void 0 : polizaEndorsement.cancel_reason) === reason.value;
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-4"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Inicio vigencia"), /*#__PURE__*/React.createElement(DatePicker, {
    className: "form-control",
    dateFormat: "dd-MM-yyyy",
    maxDate: poliza.finish_date,
    selected: poliza.start_date,
    disabled: true
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-4"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Fecha Cancelaci\xF3n"), /*#__PURE__*/React.createElement(DatePicker, {
    className: "form-control",
    dateFormat: "dd-MM-yyyy",
    minDate: poliza.start_date,
    selected: polizaEndorsementForm === null || polizaEndorsementForm === void 0 ? void 0 : (_polizaEndorsementFor = polizaEndorsementForm.poliza_params) === null || _polizaEndorsementFor === void 0 ? void 0 : _polizaEndorsementFor.finish_date,
    onChange: function onChange(item) {
      onChangeDuration({
        finish_date: item
      });
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-4"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Raz\xF3n de cancelaci\xF3n"), /*#__PURE__*/React.createElement(Select, {
    options: cancelReasons,
    defaultValue: defaultCancelReason,
    isSearchable: true,
    placeholder: "Selecciona raz\xF3n de cancelaci\xF3n...",
    onChange: function onChange(item) {
      return setPolizaEndorsementForm(_objectSpread(_objectSpread({}, polizaEndorsementForm), {}, {
        cancel_reason: item.value
      }));
    }
  }))), /*#__PURE__*/React.createElement(PrimaForm, {
    canModify: true,
    poliza: poliza,
    polizaEndorsementForm: polizaEndorsementForm,
    onChangeAmount: onChangeAmount
  }));
};

export default CancellationForm;